import React from 'react'
import PropTypes from 'prop-types'

// Placeholder shown while Stripe's iframe loads, shaped like the form it stands in for, so the
// screen does not show half a form (our own fields) before the Stripe fields appear.
// variant 'card'   - card number, expiry + CVC, consent text (+ name field / button if asked)
// variant 'wallet' - one Apple Pay / Google Pay button
const Bar = ({ width, height, className }) => (
    <span className={`placeholder rounded ${width} ${className}`} style={{ height }} />
)

Bar.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    className: PropTypes.string
}

Bar.defaultProps = {
    width: 'col-12',
    height: '46px',
    className: 'mb-3'
}

const StripeFormSkeleton = ({ variant, showName, showButton, showCheckbox }) => {
    if (variant === 'wallet') {
        return (
            <div className='placeholder-glow' aria-busy='true' aria-label='Loading payment options'>
                <Bar height='48px' className='mb-0' />
            </div>
        )
    }
    return (
        <div className='placeholder-glow' aria-busy='true' aria-label='Loading card form'>
            {showName && (
                <>
                    <Bar width='col-4' height='14px' className='mb-2' />
                    <Bar />
                </>
            )}
            <Bar width='col-3' height='14px' className='mb-2' />
            <Bar />
            <div className='d-flex gap-3 mb-3'>
                <div className='flex-fill'>
                    <Bar width='col-6' height='14px' className='mb-2' />
                    <Bar className='mb-0' />
                </div>
                <div className='flex-fill'>
                    <Bar width='col-6' height='14px' className='mb-2' />
                    <Bar className='mb-0' />
                </div>
            </div>
            <Bar height='10px' className='mb-1' />
            <Bar width='col-9' height='10px' />
            {showCheckbox && <Bar width='col-5' height='18px' />}
            {showButton && <Bar height='48px' className='mb-0 mt-1' />}
        </div>
    )
}

StripeFormSkeleton.propTypes = {
    variant: PropTypes.oneOf(['card', 'wallet']),
    showName: PropTypes.bool,
    showButton: PropTypes.bool,
    showCheckbox: PropTypes.bool
}

StripeFormSkeleton.defaultProps = {
    variant: 'card',
    showName: false,
    showButton: false,
    showCheckbox: false
}

export default StripeFormSkeleton
